/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blood-bank-association.reducer';

export const BloodBankAssociationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bloodBankAssociationEntity = useAppSelector(state => state.bloodBankAssociation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bloodBankAssociationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.detail.title">BloodBankAssociation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.id">Id</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.id}</dd>
          <dt>
            <span id="associatedDate">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.associatedDate">Associated Date</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.associatedDate}</dd>
          <dt>
            <span id="leavingDate">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.leavingDate">Leaving Date</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.leavingDate}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.lastUpdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.active">Active</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.cursor}</dd>
          <dt>
            <span id="openingTime">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.openingTime">Opening Time</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.openingTime}</dd>
          <dt>
            <span id="closeTime">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.closeTime">Close Time</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.closeTime}</dd>
          <dt>
            <span id="internal">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.internal">Internal</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.internal ? 'true' : 'false'}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.createdBy}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.modifiedBy}</dd>
          <dt>
            <span id="leftAssociation">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.leftAssociation">Left Association</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.leftAssociation ? 'true' : 'false'}</dd>
          <dt>
            <span id="entityType">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.entityType">Entity Type</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.entityType}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{bloodBankAssociationEntity.entityId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankAssociation.association">Association</Translate>
          </dt>
          <dd>{bloodBankAssociationEntity.association ? bloodBankAssociationEntity.association.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/blood-bank-association" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blood-bank-association/${bloodBankAssociationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BloodBankAssociationDetail;
